module.exports = __webpack_public_path__ + "static/media/email_white.352923d3.svg";